// @ts-nocheck

import { querySelector } from '../../../../DOMElements';
import { type HandlerProps } from '../../../../store/synchronousMiddleware';
import { smoothScrollToAnchorByParent } from '../../../../utils/smoothScroll';
import {
  flushGRNotifications,
  skipAllGRTemporaryNotifications,
  skipCurrentGRTemporaryNotification,
} from '../../actions/gr';
import { DeltaTransitionsDurations, GR_LIST_SCROLL_DURATION } from '../../constants/delta';
import { GRStateActionTypes } from '../../types/actions/gr';
import { type GRNotificationState } from '../../types/notification';
import { type GRRound } from '../../types/round';

let notificationsQueue: Array<GRNotificationState> = [];
let timeoutId = null;
let currentPromiseResolve = null;

const asyncDequeueNotifications = async (roundId: GRRound, dispatch) => {
  for (let i = 0; i < notificationsQueue.length - 1; i++) {
    const nextNotif = notificationsQueue[i + 1];

    if (nextNotif) {
      const { type, data: { betslipReference } = {} } = nextNotif;

      if (betslipReference) {
        const chipElem = querySelector(`*[data-anchorid="gr-chip-${betslipReference}"]`);
        const chipListElem = querySelector(`*[data-anchorid="gr-chip-list-${roundId}"]`);

        if (chipElem && chipListElem) {
          await smoothScrollToAnchorByParent(chipElem, chipListElem, GR_LIST_SCROLL_DURATION);
        }
      }

      if (i > 0) {
        dispatch(skipCurrentGRTemporaryNotification());
      }

      try {
        // eslint-disable-next-line no-loop-func
        await new Promise((resolve) => {
          currentPromiseResolve = resolve.bind({});
          timeoutId = setTimeout(() => {
            timeoutId = null;
            resolve();
          }, DeltaTransitionsDurations[type] ?? 0);
        });
      } finally {
        currentPromiseResolve = null;
      }
    }
  }

  dispatch(skipCurrentGRTemporaryNotification());
};

const enqueueNotifications = (notifications: Array<GRNotificationState>) => {
  notificationsQueue.push(...notifications);
};

export const handledActionTypes = [
  GRStateActionTypes.TRIGGER_NOTIFICATIONS_TRANSITIONS,
  GRStateActionTypes.CANCEL_NOTIFICATIONS_TRANSITIONS,
];

const GRNotificationsMiddlewareHandler = ({ store: { dispatch, getState }, action }: HandlerProps) => {
  const { type: actionType } = action;
  const state = getState();

  if (handledActionTypes.indexOf(actionType) !== -1) {
    if (actionType === GRStateActionTypes.TRIGGER_NOTIFICATIONS_TRANSITIONS) {
      const { tmpNotifications } = state.gr.misc;
      const { round: roundId } = state.gr.user;

      if (Array.isArray(tmpNotifications) && tmpNotifications.length) {
        enqueueNotifications(tmpNotifications);

        if (tmpNotifications.length) {
          dispatch(flushGRNotifications());
        }

        asyncDequeueNotifications(roundId, dispatch);
      }
    }

    if (actionType === GRStateActionTypes.CANCEL_NOTIFICATIONS_TRANSITIONS) {
      notificationsQueue = [];

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      if (currentPromiseResolve) {
        currentPromiseResolve();
      }

      dispatch(skipAllGRTemporaryNotifications());
    }
  }
};

export default GRNotificationsMiddlewareHandler;
